//<div data-controller="mask">
//  <%= form.label :telephone, class: "form-label" %>
//  <%= form.text_field :telephone, class: "form-control", data: {action: "input->mask#phone"} %>
//</div>

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {}

  phone(event) {
    {
      var x = event.target.value
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      event.target.value = !x[2]
        ? x[1]
        : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    }
  }
}
